import React,{useEffect,useState} from "react";
import API from "../services/api";
import "./Reimbursement.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Reimbursement(){

/* ================= STATES ================= */

const [data,setData]=useState([]);

const [searchText,setSearchText]=
useState("");

const [filterMonth,setFilterMonth]=
useState("");

const [filterYear,setFilterYear]=
useState("");

/* ================= FETCH ================= */

useEffect(()=>{

fetchReimbursements();

},[]);

const fetchReimbursements=async()=>{

try{

const res=await API.get(
"/reimbursement"
);

setData(res.data || []);

}catch(err){

console.log(err);

}

};

/* ================= APPROVE ================= */

const approveReimbursement=async(id)=>{

try{

await API.put(
`/reimbursement/approve/${id}`
);

fetchReimbursements();

}catch(err){

console.log(err);

}

};

/* ================= REJECT ================= */

const rejectReimbursement=async(id)=>{

try{

await API.put(
`/reimbursement/reject/${id}`
);

fetchReimbursements();

}catch(err){

console.log(err);

}

};

/* ================= DELETE ================= */

const deleteReimbursement=async(id)=>{

try{

await API.delete(
`/reimbursement/${id}`
);

fetchReimbursements();

}catch(err){

console.log(err);

}

};

/* ================= PDF ================= */

const generatePDF=(item)=>{

const doc=new jsPDF();

doc.setFontSize(22);

doc.text(
"Employee Reimbursement Form",
50,
20
);

/* ================= DETAILS ================= */

doc.setFontSize(12);

doc.text(
`Name : ${item.employeeName || ""}`,
20,
40
);

doc.text(
`Title : ${item.title || ""}`,
20,
50
);

doc.text(
`Employer : ${item.employer || ""}`,
20,
60
);

/* ================= EXPENSE TABLE ================= */

autoTable(doc,{

startY:80,

head:[[
"#",
"Dates of Expense(s)",
"Payment Method",
"Purpose of Expenditure(s)"
]],

body:item.expenseRows?.map(
(row,index)=>[
`#${index+1}`,
row.date,
row.paymentMethod,
row.purpose
]
)

});

/* ================= SUMMARY TABLE ================= */

autoTable(doc,{

startY:
doc.lastAutoTable.finalY+20,

head:[[
"#",
"Description",
"Air/Rail",
"Ground",
"Lodging",
"Meals",
"Other",
"Total"
]],

body:item.summaryRows?.map(
(row,index)=>[
`#${index+1}`,
row.description,
row.airRail,
row.groundTrans,
row.lodging,
row.meals,
row.other,
`₹ ${row.total}`
]
)

});

/* ================= GRAND TOTAL ================= */

doc.text(
`Expense Report Total : ₹ ${item.grandTotal}`,
20,
doc.lastAutoTable.finalY+20
);

/* ================= SIGNATURE ================= */

doc.text(
"Reimburse Signature : ____________________",
20,
doc.lastAutoTable.finalY+40
);

doc.text(
"Approved By : ____________________",
20,
doc.lastAutoTable.finalY+55
);

doc.save(
`${item.employeeName}_Reimbursement.pdf`
);

};

/* ================= YEARS ================= */

const years=[];

for(let y=2024;y<=2035;y++){

years.push(y);

}

/* ================= FILTER ================= */

const filteredData=data.filter((item)=>{

const search=
searchText.toLowerCase();

const employee=
(item.employeeName || "")
.toLowerCase();

const title=
(item.title || "")
.toLowerCase();

const employer=
(item.employer || "")
.toLowerCase();

const searchMatch=

employee.includes(search) ||

title.includes(search) ||

employer.includes(search);

if(!item.createdAt)
return true;

const itemDate=
new Date(item.createdAt);

const month=
String(
itemDate.getMonth()+1
).padStart(2,"0");

const year=
String(
itemDate.getFullYear()
);

const monthMatch=
!filterMonth ||
month===filterMonth;

const yearMatch=
!filterYear ||
year===filterYear;

return(
searchMatch &&
monthMatch &&
yearMatch
);

});

/* ================= UI ================= */

return(

<div className="container">

<h1 className="page-title">

Reimbursements

</h1>

{/* ================= FILTERS ================= */}

<div className="top-bar">

<div className="filters">

<input

type="text"

placeholder=
"Search Name / Title / Employer"

value={searchText}

onChange={(e)=>
setSearchText(e.target.value)
}

/>

<select

value={filterMonth}

onChange={(e)=>
setFilterMonth(e.target.value)
}

>

<option value="">
All Months
</option>

<option value="01">Jan</option>
<option value="02">Feb</option>
<option value="03">Mar</option>
<option value="04">Apr</option>
<option value="05">May</option>
<option value="06">Jun</option>
<option value="07">Jul</option>
<option value="08">Aug</option>
<option value="09">Sep</option>
<option value="10">Oct</option>
<option value="11">Nov</option>
<option value="12">Dec</option>

</select>

<select

value={filterYear}

onChange={(e)=>
setFilterYear(e.target.value)
}

>

<option value="">
All Years
</option>

{years.map((y)=>(

<option
key={y}
value={y}
>

{y}

</option>

))}

</select>

</div>

</div>

{/* ================= TABLE ================= */}

<table className="reimbursement-table">

<thead>

<tr>

<th>Date</th>

<th>Name</th>

<th>Title</th>

<th>Employer</th>

<th>Expense Details</th>

<th>Summary Details</th>

<th>Total</th>

<th>Status</th>

<th>PDF</th>

<th>Action</th>

</tr>

</thead>

<tbody>

{filteredData.map((item,index)=>(

<tr key={index}>
<td>
{
item.expenseRows &&
item.expenseRows.length > 0
?
item.expenseRows[0].date
:
"-"
}
</td>
<td>
{item.employeeName}
</td>

<td>
{item.title}
</td>

<td>
{item.employer}
</td>

{/* ================= EXPENSE ROWS ================= */}

<td>

<div className="inner-box">

{item.expenseRows?.map(
(row,i)=>(

<div
key={i}
className="inner-item"
>

<br/>

Date:
{row.date}

<br/>

Method:
{row.paymentMethod}

<br/>

Purpose:
{row.purpose}

<hr/>

</div>

)
)}

</div>

</td>

{/* ================= SUMMARY ROWS ================= */}

<td>

<div className="inner-box">

{item.summaryRows?.map(
(row,i)=>(

<div
key={i}
className="inner-item"
>

<br/>

Description:
{row.description}

<br/>

Air/Rail:
₹ {row.airRail}

<br/>

Ground:
₹ {row.groundTrans}

<br/>

Lodging:
₹ {row.lodging}

<br/>

Meals:
₹ {row.meals}

<br/>

Other:
₹ {row.other}

<br/>

Total:
₹ {row.total}

<hr/>

</div>

)
)}

</div>

</td>

{/* ================= GRAND TOTAL ================= */}

<td>

₹ {item.grandTotal}

</td>

{/* ================= STATUS ================= */}

<td>

<span
className={
item.status==="Approved"
?
"approved"
:
item.status==="Rejected"
?
"rejected"
:
"pending"
}
>

{item.status || "Pending"}

</span>

</td>

{/* ================= PDF ================= */}

<td>

<button

className="pdf-btn"

onClick={()=>
generatePDF(item)
}

>

PDF

</button>

</td>

{/* ================= ACTION ================= */}

<td>

<button

className="approve-btn"

onClick={()=>
approveReimbursement(item._id)
}

>

Approve

</button>

<button

className="reject-btn"

onClick={()=>
rejectReimbursement(item._id)
}

>

Reject

</button>

<button

className="delete-btn"

onClick={()=>
deleteReimbursement(item._id)
}

>

Delete

</button>

</td>

</tr>

))}

</tbody>

</table>

</div>

);

}